import Vue from 'vue';
import recipeProcedureTransformer from '../../transformers/recipeProcedure';
import store from '../../store';

const success = ({ data }) => recipeProcedureTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const recipeProcedures = store.state.recipeProcedure.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (recipeProcedures.length > 0) {
      return resolve(recipeProcedures[0]);
    }

    return Vue.$http.get(`/production/recipe_procedure/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeProcedure/show.js